export const PANORAMA_APP_DEF_ID = 'b60344aa-05b6-49e0-815e-502ffab84c07';
export const PANORAMA_GRAFANA_BASE_URL = 'https://panorama-grafana.mon.wixprod.net';
export const DEV_PORTAL_BASE_URL = 'https://bo.wix.com/dev';
export const SUCCESS_RATE_GRAFANA_INVESTIGATION_DASHBOARD_URL = 'https://panorama-grafana.mon.wixprod.net/d/QOCglcv4z/success-rate-drop-breakdown';
export const DURATION_GRAFANA_INVESTIGATION_DASHBOARD_URL = 'https://panorama-grafana.mon.wixprod.net/d/2TD775vVk/duration-increase-breakdown';
export const CLICKHOUSE_REPORT_URL = 'https://panorama.wixapps.net/api/v1/log';
export const CLICKHOUSE_BATCH_REPORT_URL = 'https://panorama.wixapps.net/api/v1/bulklog';
//# sourceMappingURL=constants.js.map